// (function(){
//   const DEBUG = !!window.RS_DEBUG;
//   const log = (...args) => { if (DEBUG) { try { console.log('[RS]', ...args); } catch(_){} } };

//   const CONFIG = {
//     baseUrl: (window.RS_EMBED_BASE_URL || 'http://localhost:5000').replace(/\/$/, ''),
//     productTitleSelector: window.RS_PRODUCT_TITLE_SELECTOR || '.ab-product .product-info > div.product__title > h1',
//     buttonText: ' Try It Virtually in My Room',
//     buttonContainerSelector: window.RS_BUTTON_CONTAINER_SELECTOR || null,
//   };

//   const FALLBACK_SELECTORS = [
//     CONFIG.productTitleSelector,
//     '.ab-product .product-info > div.product__title > h1',
//     '.product__title h1',
//     'h1.product__title',
//     'h1.product-title',
//     '.product__title',
//     '.product-title',
//     '[data-product-title]',
//     '#ProductInfo h1',
//   ].filter(Boolean);

//   function getProductName() {
//     const el = findTitleEl();
//     const name = el ? (el.textContent || '').trim() : '';
//     log('product name resolved:', name);
//     return name;
//   }

//   function createStyles() {
//     try {
//       const style = document.createElement('style');
//       style.textContent = `
//         @import url('https://fonts.googleapis.com/css2?family=Marcellus&family=Crimson+Pro:wght@300;400;500&display=swap');
//         :root{--rs-onyx:#222222;--rs-walnut:#75533B;--rs-brass:#AD9E84;--rs-desert:#DED5C2;--rs-sunlit:#F1F1E1;--rs-bone:#F2F2F2}
//         .rs-iframe-overlay{position:fixed;inset:0;background:linear-gradient(135deg,rgba(34,34,34,.75) 0%,rgba(117,83,59,.6) 100%);backdrop-filter:blur(8px);display:none;z-index:2147483646;animation:rs-fade-in .3s ease}
//         @keyframes rs-fade-in{from{opacity:0}to{opacity:1}}
//         @keyframes rs-slide-up{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
//         .rs-iframe-container{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:90%;max-width:520px;background:white;border-radius:16px;box-shadow:0 30px 80px rgba(34,34,34,.5),0 0 0 1px rgba(173,158,132,.2); display:none;z-index:2147483647;animation:rs-slide-up .4s cubic-bezier(.16,1,.3,1);overflow:hidden;}
//         .rs-modal-header{position:absolute;top:0;left:0;right:0;height:56px;backdrop-filter:blur(10px);z-index:2;display:flex;align-items:center;justify-content:center;padding:0 60px}
//         .rs-modal-title{font-family:'Marcellus',serif;font-size:14px;font-weight:400;letter-spacing:2.5px;text-transform:uppercase;color:var(--rs-onyx);margin:0}
//         .rs-iframe{width:100%;height:auto;min-height:500px;border:0;background:transparent;margin-top:56px}
//         .rs-close{position:absolute;top:12px;right:16px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border:none;background:transparent;color:var(--rs-walnut);cursor:pointer;transition:all .25s cubic-bezier(.16,1,.3,1);font-family:'Crimson Pro',serif;font-size:28px;line-height:1;font-weight:300;padding:0}
//         .rs-close:hover{color:var(--rs-onyx);transform:rotate(90deg) scale(1.1)}
//         .rs-close:active{transform:rotate(90deg) scale(.95)}
//         .rs-close:focus{outline:none}
//         .rs-trigger{display:inline-flex;align-items:center;justify-content:center;gap:.5rem;padding:14px 28px;background:var(--rs-onyx);color:var(--rs-sunlit);border:1.5px solid var(--rs-brass);cursor:pointer;font-family:'Crimson Pro',serif;font-size:15px;font-weight:400;letter-spacing:.5px;box-shadow:0 4px 12px rgba(34,34,34,.25),inset 0 1px 0 rgba(173,158,132,.15);transition:all .3s cubic-bezier(.16,1,.3,1);position:relative;overflow:hidden}
//         .rs-trigger::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,transparent 0%,rgba(173,158,132,.15) 100%);opacity:0;transition:opacity .3s ease}
//         .rs-trigger:hover{background:#1a1a1a;border-color:var(--rs-desert);box-shadow:0 6px 20px rgba(34,34,34,.35),inset 0 1px 0 rgba(173,158,132,.25);transform:translateY(-1px)}
//         .rs-trigger:hover::before{opacity:1}
//         .rs-trigger:active{transform:translateY(0);box-shadow:0 2px 8px rgba(34,34,34,.3)}
//         .rs-trigger:focus{outline:2px solid var(--rs-brass);outline-offset:3px}
//         .rs-trigger-floating{position:fixed;right:24px;bottom:24px;z-index:2147483648;box-shadow:0 8px 24px rgba(34,34,34,.4),0 0 0 1px rgba(173,158,132,.3)}
//         .form-container{background-color:white !important;height: 500px !important;}
//         `;
//       document.head.appendChild(style);
//       log('styles injected');
//     } catch(err) { log('style inject error', err); }
//   }

//   function createOverlay() {
//     const overlay = document.createElement('div');
//     overlay.className = 'rs-iframe-overlay';
//     overlay.addEventListener('click', closeModal);
//     document.body.appendChild(overlay);
//     return overlay;
//   }

//   function createContainer(url) {
//     const container = document.createElement('div');
//     container.className = 'rs-iframe-container';
//     container.setAttribute('role', 'dialog');
//     container.setAttribute('aria-modal', 'true');
//     container.setAttribute('aria-label', 'Residence Supply preview');
//     const header = document.createElement('div');
//     header.className = 'rs-modal-header';
//     const title = document.createElement('h2');
//     title.className = 'rs-modal-title';
//     title.textContent = 'Residence Supply';
//     header.appendChild(title);
//     container.appendChild(header);
//     const iframe = document.createElement('iframe');
//     iframe.className = 'rs-iframe';
//     iframe.src = url;
//     container.appendChild(iframe);
//     const close = document.createElement('button');
//     close.className = 'rs-close';
//     close.type = 'button';
//     close.setAttribute('aria-label', 'Close');
//     close.innerHTML = '×';
//     close.addEventListener('click', closeModal);
//     container.appendChild(close);
//     document.body.appendChild(container);
//     return container;
//   }

//   function openModal() {
//     try {
//       const product = encodeURIComponent(getProductName());
//       const pageUrl = encodeURIComponent(window.location.href);
//       const url = CONFIG.baseUrl + '/embed?product_name=' + product + '&page_url=' + pageUrl;
//       if (!window.__rsOverlay) window.__rsOverlay = createOverlay();
//       if (!window.__rsContainer) window.__rsContainer = createContainer(url);
//       else window.__rsContainer.querySelector('iframe').src = url;
//       window.__rsOverlay.style.display = 'block';
//       window.__rsContainer.style.display = 'block';
//       try { document.body.dataset.__rs_prev_overflow = document.body.style.overflow || ''; document.body.style.overflow = 'hidden'; } catch(_){ }
//       window.addEventListener('keydown', onKeyDown);
//       log('modal opened', url);
//     } catch(err) { log('modal open error', err); }
//   }

//   function closeModal() {
//     try {
//       if (window.__rsOverlay) window.__rsOverlay.style.display = 'none';
//       if (window.__rsContainer) window.__rsContainer.style.display = 'none';
//       try { document.body.style.overflow = document.body.dataset.__rs_prev_overflow || ''; delete document.body.dataset.__rs_prev_overflow; } catch(_){ }
//       window.removeEventListener('keydown', onKeyDown);
//       log('modal closed');
//     } catch(err) { log('modal close error', err); }
//   }

//   function findTitleEl() {
//     for (const sel of FALLBACK_SELECTORS) {
//       try {
//         const el = document.querySelector(sel);
//         if (el) { log('title found via', sel); return el; }
//       } catch (err) { log('selector error', sel, err); }
//     }
//     log('title element not found');
//     return null;
//   }

//   function findFormEl() {
//     const formSel = '.product-form, form[action^="/cart"], form[action*="/cart/add"], [data-product-form]';
//     try {
//       const el = document.querySelector(formSel);
//       if (el) log('form found'); else log('form not found');
//       return el;
//     } catch(err) { log('form selector error', err); return null; }
//   }

//   function ensureFloatingButton() {
//     if (document.querySelector('.rs-trigger-floating')) return true;
//     try {
//       const btn = document.createElement('button');
//       btn.className = 'rs-trigger rs-trigger-floating';
//       btn.type = 'button';
//       btn.textContent = CONFIG.buttonText;
//       btn.addEventListener('click', openModal);
//       document.body.appendChild(btn);
//       log('floating button added');
//       return true;
//     } catch(err) { log('floating button error', err); return false; }
//   }

//   function injectButton() {
//     try {
//       if (document.querySelector('.rs-trigger') || document.querySelector('.rs-trigger-floating')) {
//         return true;
//       }
//       // Check for custom button container first
//       if (CONFIG.buttonContainerSelector) {
//         try {
//           const container = document.querySelector(CONFIG.buttonContainerSelector);
//           if (container) {
//             const btn = document.createElement('button');
//             btn.className = 'rs-trigger';
//             btn.type = 'button';
//             btn.textContent = CONFIG.buttonText;
//             btn.addEventListener('click', openModal);
//             container.appendChild(btn);
//             log('button injected into custom container:', CONFIG.buttonContainerSelector);
//             return true;
//           }
//         } catch(err) { log('custom container error', err); }
//       }
//       const title = findTitleEl();
//       if (title && title.parentNode) {
//         const btn = document.createElement('button');
//         btn.className = 'rs-trigger';
//         btn.type = 'button';
//         btn.textContent = CONFIG.buttonText;
//         btn.addEventListener('click', openModal);
//         title.parentNode.insertBefore(btn, title.nextSibling);
//         log('button injected next to title');
//         return true;
//       }
//       const form = findFormEl();
//       if (form && form.parentNode) {
//         const btn = document.createElement('button');
//         btn.className = 'rs-trigger';
//         btn.type = 'button';
//         btn.textContent = CONFIG.buttonText;
//         btn.addEventListener('click', openModal);
//         form.parentNode.insertBefore(btn, form);
//         log('button injected near form');
//         return true;
//       }
//       const ok = ensureFloatingButton();
//       if (!ok) log('failed to add floating button');
//       return ok;
//     } catch(err) { log('injectButton error', err); return false; }
//   }

//   function onMessage(event) {
//     if (!event || !event.data) return;
//     if (event.data.type === 'rs-close-embed') closeModal();
//   }

//   function onKeyDown(event) {
//     try {
//       const key = event && (event.key || event.code);
//       if (key === 'Escape' || key === 'Esc') closeModal();
//     } catch(_){}
//   }

//   function observeTitleMount() {
//     try {
//       const observer = new MutationObserver(() => {
//         injectButton();
//       });
//       observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
//       log('mutation observer started');
//       return observer;
//     } catch(err) { log('observer error', err); return null; }
//   }

//   function periodicFallback() {
//     let tries = 0;
//     const maxTries = 80; // ~40s if interval is 500ms
//     const id = setInterval(() => {
//       if (injectButton()) {
//         clearInterval(id);
//         log('periodic fallback injected at try', tries);
//       } else if (++tries >= maxTries) {
//         clearInterval(id);
//         log('periodic fallback exhausted');
//       }
//     }, 500);
//   }

//   function wireShopifyEvents() {
//     try {
//       const w = window;
//       const re = () => injectButton();
//       ['shopify:section:load','shopify:section:unload','shopify:section:select','shopify:section:deselect','shopify:section:reorder','shopify:block:select','shopify:block:deselect'].forEach(evt => {
//         w.document.addEventListener(evt, re);
//       });
//       log('shopify events wired');
//     } catch(err) { log('shopify events error', err); }
//   }

//   function init() {
//     log('widget init');
//     createStyles();
//     injectButton();
//     observeTitleMount();
//     periodicFallback();
//     wireShopifyEvents();
//     window.addEventListener('message', onMessage);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();




// Version: 2024-10-16-20:05
(function(){
  const DEBUG = !!window.RS_DEBUG;
  const log = (...args) => { if (DEBUG) { try { console.log('[RS]', ...args); } catch(_){} } };

  const CONFIG = {
    baseUrl: (window.RS_EMBED_BASE_URL || 'http://localhost:5000').replace(/\/$/, ''),
    productTitleSelector: window.RS_PRODUCT_TITLE_SELECTOR || 'h1.product__title, h1.product-title, h1',
    buttonText: 'See this product in your space',
    buttonContainerSelector: window.RS_BUTTON_CONTAINER_SELECTOR || null,
  };

  const FALLBACK_SELECTORS = [
  CONFIG.productTitleSelector,
    '.ab-product .product-info > div.product__title > h1',
    '.product__title h1',
    'h1.product__title',
    'h1.product-title',
    '.product__title',
    '.product-title',
    '[data-product-title]',
    '#ProductInfo h1',
  ].filter(Boolean);

  function getProductName() {
    const el = findTitleEl();
    const name = el ? (el.textContent || '').trim() : '';
    log('product name resolved:', name);
    return name;
  }

  function createStyles() {
    try {
      const style = document.createElement('style');
      style.textContent = `
        @import url('https://fonts.googleapis.com/css2?family=Marcellus&family=Crimson+Pro:wght@300;400;500&display=swap');
        :root{--rs-onyx:#222222;--rs-walnut:#75533B;--rs-brass:#AD9E84;--rs-desert:#DED5C2;--rs-sunlit:#F1F1E1;--rs-bone:#F2F2F2}
        .rs-iframe-overlay{position:fixed;inset:0;background:linear-gradient(135deg,rgba(34,34,34,.75) 0%,rgba(117,83,59,.6) 100%);backdrop-filter:blur(8px);display:none;z-index:2147483646;animation:rs-fade-in .3s ease}
        @keyframes rs-fade-in{from{opacity:0}to{opacity:1}}
        @keyframes rs-slide-up{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
        .rs-iframe-container{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:92%;max-width:531px;background:#FFFFFF;border:none;box-shadow:0 30px 80px rgba(34,34,34,.5);display:none;z-index:2147483647;animation:rs-slide-up .4s cubic-bezier(.16,1,.3,1);overflow:hidden;border-radius:16px}
        .rs-iframe{width:100%;height:auto;min-height:480px;border:0;background:transparent;margin-top:0!important}
        @media (max-width: 480px){
          .rs-iframe-container{width:96%;border-radius:14px;}
          .rs-iframe{min-height:460px;}
        }
        .rs-close{position:absolute;top:12px;right:16px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border:none;background:transparent;color:var(--rs-walnut);cursor:pointer;transition:all .25s cubic-bezier(.16,1,.3,1);font-family:'Crimson Pro',serif;font-size:28px;line-height:1;font-weight:300;padding:0}
        .rs-close:hover{color:var(--rs-onyx);transform:rotate(90deg) scale(1.1)}
        .rs-close:active{transform:rotate(90deg) scale(.95)}
        .rs-close:focus{outline:none}
        .rs-trigger{display:none;align-items:center;justify-content:center;gap:.5rem;padding:14px 28px;background:var(--rs-onyx);color:var(--rs-sunlit);border:1.5px solid var(--rs-brass);cursor:pointer;font-family:'Crimson Pro',serif;font-size:15px;font-weight:400;letter-spacing:.5px;box-shadow:0 4px 12px rgba(34,34,34,.25),inset 0 1px 0 rgba(173,158,132,.15);transition:all .3s cubic-bezier(.16,1,.3,1);position:relative;overflow:hidden}
        .rs-trigger::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,transparent 0%,rgba(173,158,132,.15) 100%);opacity:0;transition:opacity .3s ease}
        .rs-trigger:hover{background:#1a1a1a;border-color:var(--rs-desert);box-shadow:0 6px 20px rgba(34,34,34,.35),inset 0 1px 0 rgba(173,158,132,.25);transform:translateY(-1px)}
        .rs-trigger:hover::before{opacity:1}
        .rs-trigger:active{transform:translateY(0);box-shadow:0 2px 8px rgba(34,34,34,.3)}
        .rs-trigger:focus{outline:2px solid var(--rs-brass);outline-offset:3px}
        .rs-trigger-floating{position:fixed;right:24px;bottom:24px;z-index:2147483648;box-shadow:0 8px 24px rgba(34,34,34,.4),0 0 0 1px rgba(173,158,132,.3)}
      `;
      document.head.appendChild(style);
      log('styles injected');
    } catch(err) { log('style inject error', err); }
  }

  function createOverlay() {
    const overlay = document.createElement('div');
    overlay.className = 'rs-iframe-overlay';
    overlay.addEventListener('click', closeModal);
    document.body.appendChild(overlay);
    return overlay;
  }

  function createContainer(url) {
    const container = document.createElement('div');
    container.className = 'rs-iframe-container';
    container.setAttribute('role', 'dialog');
    container.setAttribute('aria-modal', 'true');
    container.setAttribute('aria-label', 'Residence Supply preview');
    const iframe = document.createElement('iframe');
    iframe.className = 'rs-iframe';
    iframe.src = url;
    container.appendChild(iframe);
    const close = document.createElement('button');
    close.className = 'rs-close';
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '×';
    close.addEventListener('click', closeModal);
    container.appendChild(close);
    document.body.appendChild(container);
    return container;
  }

  function openModal() {
    try {
      const product = encodeURIComponent(getProductName());
      const pageUrl = encodeURIComponent(window.location.href);
      const url = CONFIG.baseUrl + '/embed?product_name=' + product + '&page_url=' + pageUrl;
      if (!window.__rsOverlay) window.__rsOverlay = createOverlay();
      if (!window.__rsContainer) window.__rsContainer = createContainer(url);
      else {
        // Sanitize any legacy header remnants if an old container is reused
        try {
          const legacyHeader = window.__rsContainer.querySelector('.rs-modal-header');
          if (legacyHeader) legacyHeader.remove();
          const legacyTitle = window.__rsContainer.querySelector('.rs-modal-title');
          if (legacyTitle && legacyTitle.parentElement) legacyTitle.parentElement.remove();
        } catch (_) {}
        const ifr = window.__rsContainer.querySelector('iframe');
        if (ifr) {
          ifr.style.marginTop = '0px';
          ifr.src = url;
        }
      }
      window.__rsOverlay.style.display = 'block';
      window.__rsContainer.style.display = 'block';
      try { document.body.dataset.__rs_prev_overflow = document.body.style.overflow || ''; document.body.style.overflow = 'hidden'; } catch(_){ }
      window.addEventListener('keydown', onKeyDown);
      log('modal opened', url);
    } catch(err) { log('modal open error', err); }
  }

  function closeModal() {
    try {
      if (window.__rsOverlay) window.__rsOverlay.style.display = 'none';
      if (window.__rsContainer) window.__rsContainer.style.display = 'none';
      try { document.body.style.overflow = document.body.dataset.__rs_prev_overflow || ''; delete document.body.dataset.__rs_prev_overflow; } catch(_){ }
      window.removeEventListener('keydown', onKeyDown);
      log('modal closed');
    } catch(err) { log('modal close error', err); }
  }

  function findTitleEl() {
    for (const sel of FALLBACK_SELECTORS) {
      try {
        const el = document.querySelector(sel);
        if (el) { log('title found via', sel); return el; }
      } catch (err) { log('selector error', sel, err); }
    }
    log('title element not found');
    return null;
  }

  function findFormEl() {
    const formSel = '.product-form, form[action^="/cart"], form[action*="/cart/add"], [data-product-form]';
    try {
      const el = document.querySelector(formSel);
      if (el) log('form found'); else log('form not found');
      return el;
    } catch(err) { log('form selector error', err); return null; }
  }

  function ensureFloatingButton() {
    if (document.querySelector('.rs-trigger-floating')) return true;
    try {
      const btn = document.createElement('button');
      btn.className = 'rs-trigger rs-trigger-floating';
      btn.type = 'button';
      btn.textContent = CONFIG.buttonText;
      btn.addEventListener('click', openModal);
      document.body.appendChild(btn);
      log('floating button added');
      return true;
    } catch(err) { log('floating button error', err); return false; }
  }

  function injectButton() {
    try {
      if (document.querySelector('.rs-trigger') || document.querySelector('.rs-trigger-floating')) {
        return true;
      }
      // Check for custom button container first
      if (CONFIG.buttonContainerSelector) {
        try {
          const container = document.querySelector(CONFIG.buttonContainerSelector);
          if (container) {
            const btn = document.createElement('button');
            btn.className = 'rs-trigger';
            btn.type = 'button';
            btn.textContent = CONFIG.buttonText;
            btn.addEventListener('click', openModal);
            container.appendChild(btn);
            log('button injected into custom container:', CONFIG.buttonContainerSelector);
            return true;
          }
        } catch(err) { log('custom container error', err); }
      }
      const title = findTitleEl();
      if (title && title.parentNode) {
        const btn = document.createElement('button');
        btn.className = 'rs-trigger';
        btn.type = 'button';
        btn.textContent = CONFIG.buttonText;
        btn.addEventListener('click', openModal);
        title.parentNode.insertBefore(btn, title.nextSibling);
        log('button injected next to title');
        return true;
      }
      const form = findFormEl();
      if (form && form.parentNode) {
        const btn = document.createElement('button');
        btn.className = 'rs-trigger';
        btn.type = 'button';
        btn.textContent = CONFIG.buttonText;
        btn.addEventListener('click', openModal);
        form.parentNode.insertBefore(btn, form);
        log('button injected near form');
        return true;
      }
      const ok = ensureFloatingButton();
      if (!ok) log('failed to add floating button');
      return ok;
    } catch(err) { log('injectButton error', err); return false; }
  }

  function getProductImage() {
    // Try primary selector first
    const primarySelector = '#gallery-viewer';
 
    try {
      const el = document.querySelector(primarySelector);
      
      if (el) {
        // Try to find img tag within
        const img = el.querySelector('img');
        if (img && img.src) {
          log('product image found via primary selector:', img.src);
          return img.src;
        }
        // Try background image
        const bgImage = window.getComputedStyle(el).backgroundImage;
        if (bgImage && bgImage !== 'none') {
          const match = bgImage.match(/url\(['"]?([^'"]+)['"]?\)/);
          if (match && match[1]) {
            log('product image found via background:', match[1]);
            return match[1];
          }
        }
      }
    } catch(err) { log('primary selector error', err); }
    
    // Fallback selectors
    const fallbacks = [
      '.product__media img',
      '.product-single__photo img',
      '[data-product-featured-media] img',
      '.product__featured-image img',
      '.product-gallery img',
      '.product-image img',
      'img[src*="product"]',
    ];
    
    for (const sel of fallbacks) {
      try {
        const img = document.querySelector(sel);
        if (img && img.src) {
          log('product image found via fallback:', sel, img.src);
          return img.src;
        }
      } catch(err) { log('fallback selector error', sel, err); }
    }
    
    log('product image not found');
    return null;
  }

  function onMessage(event) {
    if (!event || !event.data) return;
    if (event.data.type === 'rs-close-embed') closeModal();
    if (event.data.type === 'rs-request-product-image') {
      const imageUrl = getProductImage();
      if (imageUrl && window.__rsContainer) {
        const iframe = window.__rsContainer.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.postMessage({ 
            type: 'rs-product-image', 
            imageUrl: imageUrl 
          }, '*');
          log('product image sent to iframe:', imageUrl);
        }
      }
    }
  }

  function onKeyDown(event) {
    try {
      const key = event && (event.key || event.code);
      if (key === 'Escape' || key === 'Esc') closeModal();
    } catch(_){}
  }

  function observeTitleMount() {
    try {
      const observer = new MutationObserver(() => {
        injectButton();
      });
      observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
      log('mutation observer started');
      return observer;
    } catch(err) { log('observer error', err); return null; }
  }

  function periodicFallback() {
    let tries = 0;
    const maxTries = 80; // ~40s if interval is 500ms
    const id = setInterval(() => {
      if (injectButton()) {
        clearInterval(id);
        log('periodic fallback injected at try', tries);
      } else if (++tries >= maxTries) {
        clearInterval(id);
        log('periodic fallback exhausted');
      }
    }, 500);
  }

  function wireShopifyEvents() {
    try {
      const w = window;
      const re = () => injectButton();
      ['shopify:section:load','shopify:section:unload','shopify:section:select','shopify:section:deselect','shopify:section:reorder','shopify:block:select','shopify:block:deselect'].forEach(evt => {
        w.document.addEventListener(evt, re);
      });
      log('shopify events wired');
    } catch(err) { log('shopify events error', err); }
  }

  function init() {
    log('widget init');
    createStyles();
    injectButton();
    observeTitleMount();
    periodicFallback();
    wireShopifyEvents();
    window.addEventListener('message', onMessage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();









// (function(){
//   const DEBUG = !!window.RS_DEBUG;
//   const log = (...args) => { if (DEBUG) { try { console.log('[RS]', ...args); } catch(_){} } };

//   const CONFIG = {
//     baseUrl: (window.RS_EMBED_BASE_URL || 'http://localhost:5000').replace(/\/$/, ''),
//     productTitleSelector: window.RS_PRODUCT_TITLE_SELECTOR || '.ab-product .product-info > div.product__title > h1',
//     buttonText: ' Try It Virtually in My Room',
//     buttonContainerSelector: window.RS_BUTTON_CONTAINER_SELECTOR || null,
//   };

//   const FALLBACK_SELECTORS = [
//     CONFIG.productTitleSelector,
//     '.ab-product .product-info > div.product__title > h1',
//     '.product__title h1',
//     'h1.product__title',
//     'h1.product-title',
//     '.product__title',
//     '.product-title',
//     '[data-product-title]',
//     '#ProductInfo h1',
//   ].filter(Boolean);

//   function getProductName() {
//     const el = findTitleEl();
//     const name = el ? (el.textContent || '').trim() : '';
//     log('product name resolved:', name);
//     return name;
//   }

//   function createStyles() {
//     try {
//       const style = document.createElement('style');
//       style.textContent = `
//         @import url('https://fonts.googleapis.com/css2?family=Marcellus&family=Crimson+Pro:wght@300;400;500&display=swap');
//         :root{--rs-onyx:#222222;--rs-walnut:#75533B;--rs-brass:#AD9E84;--rs-desert:#DED5C2;--rs-sunlit:#F1F1E1;--rs-bone:#F2F2F2}
//         .rs-iframe-overlay{position:fixed;inset:0;background:linear-gradient(135deg,rgba(34,34,34,.75) 0%,rgba(117,83,59,.6) 100%);backdrop-filter:blur(8px);display:none;z-index:2147483646;animation:rs-fade-in .3s ease}
//         @keyframes rs-fade-in{from{opacity:0}to{opacity:1}}
//         @keyframes rs-slide-up{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
//         .rs-iframe-container{position:fixed;top:50%;left:50%;transform:translate(-50%,-50%);width:90%;max-width:520px;background:#F2F2F2;border:2px solid var(--rs-brass);box-shadow:0 30px 80px rgba(34,34,34,.5),0 0 0 1px rgba(173,158,132,.2),inset 0 1px 0 rgba(255,255,255,.3);display:none;z-index:2147483647;animation:rs-slide-up .4s cubic-bezier(.16,1,.3,1);overflow:hidden;border-radius:2px}
//         .rs-modal-header{position:absolute;top:0;left:0;right:0;height:56px;background:linear-gradient(180deg,var(--rs-sunlit) 0%,rgba(241,241,225,.95) 100%);border-bottom:1px solid var(--rs-brass);backdrop-filter:blur(10px);z-index:2;display:flex;align-items:center;justify-content:center;padding:0 60px}
//         .rs-modal-title{font-family:'Marcellus',serif;font-size:14px;font-weight:400;letter-spacing:2.5px;text-transform:uppercase;color:var(--rs-onyx);margin:0}
//         .rs-iframe{width:100%;height:auto;min-height:500px;border:0;background:transparent;margin-top:56px}
//         .rs-close{position:absolute;top:12px;right:16px;z-index:3;display:inline-flex;align-items:center;justify-content:center;width:32px;height:32px;border:none;background:transparent;color:var(--rs-walnut);cursor:pointer;transition:all .25s cubic-bezier(.16,1,.3,1);font-family:'Crimson Pro',serif;font-size:28px;line-height:1;font-weight:300;padding:0}
//         .rs-close:hover{color:var(--rs-onyx);transform:rotate(90deg) scale(1.1)}
//         .rs-close:active{transform:rotate(90deg) scale(.95)}
//         .rs-close:focus{outline:none}
//         .rs-trigger{display:inline-flex;align-items:center;justify-content:center;gap:.5rem;padding:14px 28px;background:var(--rs-onyx);color:var(--rs-sunlit);border:1.5px solid var(--rs-brass);cursor:pointer;font-family:'Crimson Pro',serif;font-size:15px;font-weight:400;letter-spacing:.5px;box-shadow:0 4px 12px rgba(34,34,34,.25),inset 0 1px 0 rgba(173,158,132,.15);transition:all .3s cubic-bezier(.16,1,.3,1);position:relative;overflow:hidden}
//         .rs-trigger::before{content:'';position:absolute;inset:0;background:linear-gradient(135deg,transparent 0%,rgba(173,158,132,.15) 100%);opacity:0;transition:opacity .3s ease}
//         .rs-trigger:hover{background:#1a1a1a;border-color:var(--rs-desert);box-shadow:0 6px 20px rgba(34,34,34,.35),inset 0 1px 0 rgba(173,158,132,.25);transform:translateY(-1px)}
//         .rs-trigger:hover::before{opacity:1}
//         .rs-trigger:active{transform:translateY(0);box-shadow:0 2px 8px rgba(34,34,34,.3)}
//         .rs-trigger:focus{outline:2px solid var(--rs-brass);outline-offset:3px}
//         .rs-trigger-floating{position:fixed;right:24px;bottom:24px;z-index:2147483648;box-shadow:0 8px 24px rgba(34,34,34,.4),0 0 0 1px rgba(173,158,132,.3)}
//       `;
//       document.head.appendChild(style);
//       log('styles injected');
//     } catch(err) { log('style inject error', err); }
//   }

//   function createOverlay() {
//     const overlay = document.createElement('div');
//     overlay.className = 'rs-iframe-overlay';
//     overlay.addEventListener('click', closeModal);
//     document.body.appendChild(overlay);
//     return overlay;
//   }

//   function createContainer(url) {
//     const container = document.createElement('div');
//     container.className = 'rs-iframe-container';
//     container.setAttribute('role', 'dialog');
//     container.setAttribute('aria-modal', 'true');
//     container.setAttribute('aria-label', 'Residence Supply preview');
//     const header = document.createElement('div');
//     header.className = 'rs-modal-header';
//     const title = document.createElement('h2');
//     title.className = 'rs-modal-title';
//     title.textContent = 'Residence Supply';
//     header.appendChild(title);
//     container.appendChild(header);
//     const iframe = document.createElement('iframe');
//     iframe.className = 'rs-iframe';
//     iframe.src = url;
//     container.appendChild(iframe);
//     const close = document.createElement('button');
//     close.className = 'rs-close';
//     close.type = 'button';
//     close.setAttribute('aria-label', 'Close');
//     close.innerHTML = '×';
//     close.addEventListener('click', closeModal);
//     container.appendChild(close);
//     document.body.appendChild(container);
//     return container;
//   }

//   function openModal() {
//     try {
//       const product = encodeURIComponent(getProductName());
//       const pageUrl = encodeURIComponent(window.location.href);
//       const url = CONFIG.baseUrl + '/embed?product_name=' + product + '&page_url=' + pageUrl;
//       if (!window.__rsOverlay) window.__rsOverlay = createOverlay();
//       if (!window.__rsContainer) window.__rsContainer = createContainer(url);
//       else window.__rsContainer.querySelector('iframe').src = url;
//       window.__rsOverlay.style.display = 'block';
//       window.__rsContainer.style.display = 'block';
//       try { document.body.dataset.__rs_prev_overflow = document.body.style.overflow || ''; document.body.style.overflow = 'hidden'; } catch(_){ }
//       window.addEventListener('keydown', onKeyDown);
//       log('modal opened', url);
//     } catch(err) { log('modal open error', err); }
//   }

//   function closeModal() {
//     try {
//       if (window.__rsOverlay) window.__rsOverlay.style.display = 'none';
//       if (window.__rsContainer) window.__rsContainer.style.display = 'none';
//       try { document.body.style.overflow = document.body.dataset.__rs_prev_overflow || ''; delete document.body.dataset.__rs_prev_overflow; } catch(_){ }
//       window.removeEventListener('keydown', onKeyDown);
//       log('modal closed');
//     } catch(err) { log('modal close error', err); }
//   }

//   function findTitleEl() {
//     for (const sel of FALLBACK_SELECTORS) {
//       try {
//         const el = document.querySelector(sel);
//         if (el) { log('title found via', sel); return el; }
//       } catch (err) { log('selector error', sel, err); }
//     }
//     log('title element not found');
//     return null;
//   }

//   function findFormEl() {
//     const formSel = '.product-form, form[action^="/cart"], form[action*="/cart/add"], [data-product-form]';
//     try {
//       const el = document.querySelector(formSel);
//       if (el) log('form found'); else log('form not found');
//       return el;
//     } catch(err) { log('form selector error', err); return null; }
//   }

//   function ensureFloatingButton() {
//     if (document.querySelector('.rs-trigger-floating')) return true;
//     try {
//       const btn = document.createElement('button');
//       btn.className = 'rs-trigger rs-trigger-floating';
//       btn.type = 'button';
//       btn.textContent = CONFIG.buttonText;
//       btn.addEventListener('click', openModal);
//       document.body.appendChild(btn);
//       log('floating button added');
//       return true;
//     } catch(err) { log('floating button error', err); return false; }
//   }

//   function injectButton() {
//     try {
//       if (document.querySelector('.rs-trigger') || document.querySelector('.rs-trigger-floating')) {
//         return true;
//       }
//       // Check for custom button container first
//       if (CONFIG.buttonContainerSelector) {
//         try {
//           const container = document.querySelector(CONFIG.buttonContainerSelector);
//           if (container) {
//             const btn = document.createElement('button');
//             btn.className = 'rs-trigger';
//             btn.type = 'button';
//             btn.textContent = CONFIG.buttonText;
//             btn.addEventListener('click', openModal);
//             container.appendChild(btn);
//             log('button injected into custom container:', CONFIG.buttonContainerSelector);
//             return true;
//           }
//         } catch(err) { log('custom container error', err); }
//       }
//       const title = findTitleEl();
//       if (title && title.parentNode) {
//         const btn = document.createElement('button');
//         btn.className = 'rs-trigger';
//         btn.type = 'button';
//         btn.textContent = CONFIG.buttonText;
//         btn.addEventListener('click', openModal);
//         title.parentNode.insertBefore(btn, title.nextSibling);
//         log('button injected next to title');
//         return true;
//       }
//       const form = findFormEl();
//       if (form && form.parentNode) {
//         const btn = document.createElement('button');
//         btn.className = 'rs-trigger';
//         btn.type = 'button';
//         btn.textContent = CONFIG.buttonText;
//         btn.addEventListener('click', openModal);
//         form.parentNode.insertBefore(btn, form);
//         log('button injected near form');
//         return true;
//       }
//       const ok = ensureFloatingButton();
//       if (!ok) log('failed to add floating button');
//       return ok;
//     } catch(err) { log('injectButton error', err); return false; }
//   }

//   function onMessage(event) {
//     if (!event || !event.data) return;
//     if (event.data.type === 'rs-close-embed') closeModal();
//   }

//   function onKeyDown(event) {
//     try {
//       const key = event && (event.key || event.code);
//       if (key === 'Escape' || key === 'Esc') closeModal();
//     } catch(_){}
//   }

//   function observeTitleMount() {
//     try {
//       const observer = new MutationObserver(() => {
//         injectButton();
//       });
//       observer.observe(document.documentElement || document.body, { childList: true, subtree: true });
//       log('mutation observer started');
//       return observer;
//     } catch(err) { log('observer error', err); return null; }
//   }

//   function periodicFallback() {
//     let tries = 0;
//     const maxTries = 80; // ~40s if interval is 500ms
//     const id = setInterval(() => {
//       if (injectButton()) {
//         clearInterval(id);
//         log('periodic fallback injected at try', tries);
//       } else if (++tries >= maxTries) {
//         clearInterval(id);
//         log('periodic fallback exhausted');
//       }
//     }, 500);
//   }

//   function wireShopifyEvents() {
//     try {
//       const w = window;
//       const re = () => injectButton();
//       ['shopify:section:load','shopify:section:unload','shopify:section:select','shopify:section:deselect','shopify:section:reorder','shopify:block:select','shopify:block:deselect'].forEach(evt => {
//         w.document.addEventListener(evt, re);
//       });
//       log('shopify events wired');
//     } catch(err) { log('shopify events error', err); }
//   }

//   function init() {
//     log('widget init');
//     createStyles();
//     injectButton();
//     observeTitleMount();
//     periodicFallback();
//     wireShopifyEvents();
//     window.addEventListener('message', onMessage);
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', init);
//   } else {
//     init();
//   }
// })();